import { P } from 'components'
import TermsAndConditionsConsent from 'components/TermsAndConditions'
import { useState } from 'react'

const Tnc = () => {
  const [isTNCOpen, setIsTNCOpen] = useState(false)
  const [titleId, setTitleId] = useState(null)

  return (
    <div className="pt-2">
      <TermsAndConditionsConsent
        isOpen={isTNCOpen}
        handleClose={() => setIsTNCOpen(false)}
        titleTarget={titleId}
      />
      <p className="text-center">
        <P size="regular">
          Dengan masuk atau daftar, kamu menyetujui{' '}
          <span
            className="text-primary"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setIsTNCOpen(true)
              setTitleId('micro-credit')
            }}
          >
            {' '}
            Ketentuan Layanan
          </span>{' '}
          dan
          <span
            className="text-primary"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setIsTNCOpen(true)
              setTitleId('privacy')
            }}
          >
            {' '}
            Kebijakan Privasi
          </span>{' '}
          dari PasarMIKRO
        </P>
      </p>
      <div className="text-xs text-center text-muted">
        {process.env.REACT_APP_VERSION}
      </div>
    </div>
  )
}

export default Tnc
